import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class ServisniPaketyProvider extends BaseApi {
	async filterInit(params: Record<string, any>) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/FilterInit`, params);
	}

	async prepocetCeny(params: Record<string, any>) {
		return this.post(`/${DMS_MODULE}/${NAME}/PrepocetCeny`, params);
	}

	async odepisPp(params: object) {
		return this.post(`/${DMS_MODULE}/${NAME}/OdepisPolozkyPP`, params);
	}

	async odepisNd(params: Record<string, any>) {
		return this.post(`/${DMS_MODULE}/${NAME}/OdepisPolozkyND`, params);
	}

	async deletePacket(id: number) {
		return this.deleteEntity(id);
	}

	async pridaniPaketuNaZakazku(params: Record<string, any>) {
		return this.post(`/${DMS_MODULE}/${NAME}/PridaniPaketuNaZakazku`, params);
	}

	async rozpadPacketu(sdId: Number, zakazkaId: Number) {
		return this.post(`/${DMS_MODULE}/${NAME}/Rozpad?snId=${sdId}&zakazkaId=${zakazkaId}`);
	}
}

export const provider = new ServisniPaketyProvider(DMS_MODULE, NAME);
